import React from 'react';
import { Query } from 'react-apollo';
import { GET_SEEN_PRODUCTS } from '../../queries';
import { getProductsWithOneImage } from '../../utils/misc';
import ProductList from '../product-list/product-list';

const SeenProducts = () => {
  return (
    <Query query={GET_SEEN_PRODUCTS}>
      {({ loading, error, data }) => {
        if (loading) return 'loading';
        if (error) return 'cannot load seen products';
        const seenProducts = getProductsWithOneImage(data.seenProducts);
        return (
          <div>
            <h2>Нещодавно переглянуті</h2>
            <ProductList products={seenProducts} />
          </div>
        );
      }}
    </Query>
  );
};

export default SeenProducts;
